"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLoginNewAccountListener = exports.attachLoggedInEventListener = exports.removeLoginClickListener = exports.addLoginClickListener = void 0;
var redirect_1 = require("../../build-babel/redirect/redirect");
var config_1 = __importDefault(require("../../build-babel/auth/client/config"));
var EVENT_LOGIN_KEY = 'event';
var EVENT_LOGIN_VALUE = 'userLoggedIn';
var REDIRECT_TIMEOUT = 5 * 1000;
var LOGIN_BUTTON_ID = 'next';
var FEDERATION_LOGIN_BUTTON_ID = 'FederatedExchange';
var REGISTER_NEW_ACCOUNT_BUTTON_ID = 'continue';
var loginClickListener = function loginClickListener() {
  setUserLoggedInEvent();
};
var setUserLoggedInEvent = function setUserLoggedInEvent() {
  localStorage.setItem(EVENT_LOGIN_KEY, EVENT_LOGIN_VALUE);
};
var removeUserLoggedInEvent = function removeUserLoggedInEvent() {
  localStorage.removeItem(EVENT_LOGIN_KEY);
};
var storageLoggedInListener = function storageLoggedInListener(event) {
  if (event.key === EVENT_LOGIN_KEY) {
    removeUserLoggedInEvent();
    if (event.newValue === EVENT_LOGIN_VALUE) {
      var envConfig = (0, config_1["default"])();
      if (envConfig) {
        setTimeout(function () {
          var _a;
          return (0, redirect_1.makeRedirectTo)("".concat((_a = envConfig.auth) === null || _a === void 0 ? void 0 : _a.redirectUri, "/redirect.html") || envConfig.homepageUri);
        }, REDIRECT_TIMEOUT);
      }
    }
  }
};
var addLoginClickListener = function addLoginClickListener() {
  var loginButton = document.getElementById(LOGIN_BUTTON_ID);
  var federationLoginButton = document.getElementById(FEDERATION_LOGIN_BUTTON_ID);
  if (loginButton) {
    loginButton.addEventListener('click', loginClickListener);
  }
  if (federationLoginButton) {
    federationLoginButton.addEventListener('click', loginClickListener);
  }
};
exports.addLoginClickListener = addLoginClickListener;
var removeLoginClickListener = function removeLoginClickListener() {
  removeLoggedInEventListener();
  removeUserLoggedInEvent();
  var loginButton = document.getElementById(LOGIN_BUTTON_ID);
  var federationLoginButton = document.getElementById(FEDERATION_LOGIN_BUTTON_ID);
  var registerNewAccountButton = document.getElementById(REGISTER_NEW_ACCOUNT_BUTTON_ID);
  if (loginButton) {
    loginButton.removeEventListener('click', loginClickListener);
  }
  if (federationLoginButton) {
    federationLoginButton.removeEventListener('click', loginClickListener);
  }
  if (registerNewAccountButton) {
    registerNewAccountButton.removeEventListener('click', loginClickListener);
  }
};
exports.removeLoginClickListener = removeLoginClickListener;
var attachLoggedInEventListener = function attachLoggedInEventListener() {
  window.addEventListener('storage', storageLoggedInListener);
};
exports.attachLoggedInEventListener = attachLoggedInEventListener;
var removeLoggedInEventListener = function removeLoggedInEventListener() {
  window.removeEventListener('storage', storageLoggedInListener);
};
var getFormElements = function getFormElements() {
  return {
    select: document.getElementById('jobTitle'),
    password: document.getElementById('newPassword'),
    confirmPassword: document.getElementById('reenterPassword'),
    firstCheckbox: document.getElementById('extension_termsOfUseConsentChoice_AgreeToTermsOfUseConsentYes'),
    secondLi: document.querySelector('.extension_termsOfUseConsentChoiceSecond_li'),
    secondCheckbox: document.getElementById('extension_termsOfUseConsentChoiceSecond_AgreeToTermsOfUseConsentYes'),
    submitButton: document.getElementById(REGISTER_NEW_ACCOUNT_BUTTON_ID)
  };
};
var validateForm = function validateForm(elements) {
  var _a, _b, _c, _d, _e;
  return ((_a = elements.select) === null || _a === void 0 ? void 0 : _a.value.length) > 0 && ((_b = elements.password) === null || _b === void 0 ? void 0 : _b.value.length) > 0 && ((_c = elements.confirmPassword) === null || _c === void 0 ? void 0 : _c.value.length) > 0 && ((_d = elements.firstCheckbox) === null || _d === void 0 ? void 0 : _d.checked) && ((_e = elements.secondCheckbox) === null || _e === void 0 ? void 0 : _e.checked);
};
var registerNewAccountListener = function registerNewAccountListener() {
  var secondLi = document.querySelector('.extension_termsOfUseConsentChoiceSecond_li');
  if (secondLi === null || secondLi === void 0 ? void 0 : secondLi.checkVisibility()) {
    var checkbox = document.getElementById('extension_termsOfUseConsentChoiceSecond_AgreeToTermsOfUseConsentYes');
    if (checkbox === null || checkbox === void 0 ? void 0 : checkbox.checked) {
      removeErrorDiv();
    } else {
      showErrorDiv();
    }
  }
};
var showErrorDiv = function showErrorDiv() {
  var errorDiv = document.getElementById('second_tou_error');
  if (errorDiv && !errorDiv.classList.contains('show')) {
    errorDiv.classList.add('show');
    errorDiv.innerHTML = 'This information is required.';
  }
};
var removeErrorDiv = function removeErrorDiv() {
  var errorDiv = document.getElementById('second_tou_error');
  if (errorDiv === null || errorDiv === void 0 ? void 0 : errorDiv.classList.contains('show')) {
    errorDiv.classList.remove('show');
    errorDiv.innerHTML = '';
  }
};
var addLoginNewAccountListener = function addLoginNewAccountListener() {
  var _a;
  var elements = getFormElements();
  if (elements.submitButton) {
    elements.submitButton.addEventListener('click', loginClickListener);
    if ((_a = elements.secondLi) === null || _a === void 0 ? void 0 : _a.checkVisibility()) {
      elements.submitButton.addEventListener('click', registerNewAccountListener);
      elements.submitButton.disabled = true;
      document.addEventListener('change', function () {
        var _a;
        elements.submitButton.disabled = ((_a = elements.secondLi) === null || _a === void 0 ? void 0 : _a.checkVisibility()) && !validateForm(elements);
      });
    }
  }
};
exports.addLoginNewAccountListener = addLoginNewAccountListener;
//# sourceMappingURL=login.js.map